<template>
	<v-tab-item>
		<v-row no-gutters class="mt-2" justify="space-between">
			<h3 class="text-h6 font-weight-bold">ゴム生地情報</h3>
			<TemplateDeleteDialog
				ref="deleteDialog"
				v-if="rubber.status == 'ongoing'"
				:openBtnColor="'secondary'"
			>
				<template v-slot:text>
					<div class="py-2">
						削除すると元に戻すことはできません。
						<br />
						アーカイブすると{{
							rubber.name
						}}は使用不可能になりますが、後で使用可能に戻すことが可能です。
					</div>
				</template>
				<template v-slot:button>
					<v-row justify="space-around" no-gutters>
						<v-btn class="ma-1" @click="updateStatus('deleted')" dense dark color="red">
							<v-icon class="mr-2">mdi-delete</v-icon>
							削除する
						</v-btn>
						<v-btn class="ma-1" @click="updateStatus('archived')" dense dark color="grey">
							<v-icon class="mr-2">mdi-archive</v-icon> アーカイブする</v-btn
						>
					</v-row>
				</template>
			</TemplateDeleteDialog>
			<v-row no-gutters v-else-if="rubber.status == 'archived'" justify="end">
				<TemplateDeleteDialog ref="deleteDialog" :openBtnColor="'secondary'" :openBtnClass="'mr-2'">
					<template v-slot:icon>
						<v-icon class="mr-2">mdi-archive-arrow-up-outline</v-icon>
					</template>
					<template v-slot:btn-text> 使用可能にする </template>
					<template v-slot:title> 本当に使用可能に戻しますか </template>
					<template v-slot:text>
						<div class="py-2">使用可能にすると工程での塗料選択時に選択可能となります。</div>
					</template>
					<template v-slot:button>
						<v-row justify="space-around" no-gutters>
							<v-btn class="ma-1" @click="updateStatus('ongoing')" dense dark color="red">
								<v-icon class="mr-2">mdi-delete</v-icon>
								使用可能にする
							</v-btn>
						</v-row>
					</template>
				</TemplateDeleteDialog>
				<TemplateDeleteDialog ref="deleteDialog" :openBtnColor="'secondary'">
					<template v-slot:text>
						<div class="py-2">削除すると元に戻すことはできません。</div>
					</template>
					<template v-slot:button>
						<v-row justify="space-around" no-gutters>
							<v-btn class="ma-1" @click="updateStatus('deleted')" dense dark color="red">
								<v-icon class="mr-2">mdi-delete</v-icon>
								削除する
							</v-btn>
						</v-row>
					</template>
				</TemplateDeleteDialog>
			</v-row>
		</v-row>
		<table width="100%" class="mt-2 show-dialog-table">
			<tbody v-if="rubber && !isDeleted">
				<ShowDetailRecord :columnName="'ゴム生地名'">
					<template v-slot:td>
						<EditableTd
							:url="url"
							:value="rubber.name"
							:modelName="'rubber'"
							:columnName="'name'"
							:rules="[rules.required]"
							:authorized="authority"
							@update-column="updateColumn($event)"
						/>
					</template>
				</ShowDetailRecord>
				<ShowDetailRecord :columnName="'ステータス'" :value="rubber.status_ja" />
				<ShowDetailRecord :columnName="'特記事項'">
					<template v-slot:td>
						<EditableTd
							:url="url"
							:value="rubber.memo"
							:modelName="'rubber'"
							:columnName="'memo'"
							:formType="'textarea'"
							:authorized="authority"
							@update-column="updateColumn($event)"
						/>
					</template>
				</ShowDetailRecord>
				<ShowDetailRecord
					:columnName="'最終更新日'"
					:value="common.formatDateTime(rubber.updated_at)"
				/>
				<ShowDetailRecord
					:columnName="'登録日'"
					:value="common.formatDateTime(rubber.created_at)"
				/>
			</tbody>
		</table>
	</v-tab-item>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import EditableTd from "../../shared/EditableTd.vue"
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"

export default {
	props: {
		rubber: {
			type: Object,
			default: true,
		},
		authority: {
			type: Boolean,
			default: false,
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		EditableTd,
		TemplateDeleteDialog,
		ShowDetailRecord,
	},
	data() {
		return {
			common,
			rules,
			isDeleted: false,
		}
	},
	methods: {
		updateColumn(newVal) {
			this.$set(this.rubber, "name", newVal.name)
			this.$set(this.rubber, "memo", newVal.memo)
			this.$set(this.rubber, "status_ja", newVal.status_ja)
			this.$set(this.rubber, "status", newVal.status)
			this.$set(this.rubber, "updated_at", newVal.updated_at)
			this.$store.dispatch("setFlash", {
				text: "更新しました",
				type: "notice",
			})
		},
		updateStatus(status) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubbers/${this.rubber.id}`
			axios
				.patch(url, { rubber: { status: status } }, { headers })
				.then((res) => {
					let message = null
					if (res.data.status == "deleted") {
						message = `${this.rubber.name}を削除しました。`
						this.isDeleted = true
					} else if (res.data.status == "archived") {
						message = `${this.rubber.name}をアーカイブしました。`
					} else if (res.data.status == "ongoing") {
						message = "使用可能にしました。"
					}
					this.$store.dispatch("setFlash", {
						text: message,
						type: "notice",
					})
					this.$refs.deleteDialog.dialog = false
					this.$set(this.rubber, "status_ja", res.data.status_ja)
					this.$set(this.rubber, "status", res.data.status)
				})
				.catch((err) => errorHandling.errorResponse(err))
		},
	},
	computed: {
		url() {
			return `/erp/v1/rubber/rubbers/${this.rubber.id}`
		},
		setRubber: {
			get() {
				return this.rubber
			},
			set(newVal) {
				return this.$emit("update:rubber", newVal)
			},
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.fetchRubber()
			} else if (oldVal == true && newVal == false) {
			}
		},
		deep: true,
	},
}
</script>
